import React from "react";

const WarrantyRibbon = ({
  width = "17px",
  height = "17px",
  fill = "#d71540",
  ...props
}) => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 543 543"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fill}
    {...props}
  >
    <circle cx="266.67" cy="206.83" r="85.625" fill={fill} />
    <path
      d="M468.08 199.25a34.421 34.421 0 007.164-21.018 34.442 34.442 0 00-14.205-27.857l-14.584-10.583a34.452 34.452 0 01-14.083-30.834L433.914 91c.095-1.043.143-2.09.143-3.138 0-18.149-14.356-33.339-32.477-34.362l-18-1a34.453 34.453 0 01-28.5-18.333l-8.333-15.959A34.458 34.458 0 00316.35-.068a34.416 34.416 0 00-17.061 4.526l-15.667 8.875a34.45 34.45 0 01-33.917 0l-15.666-8.875a34.427 34.427 0 00-16.962-4.469 34.458 34.458 0 00-30.455 18.386l-8.333 15.958a34.452 34.452 0 01-28.5 18.334l-18 1c-18.121 1.023-32.477 16.212-32.477 34.362 0 1.047.048 2.094.143 3.138l1.542 17.958a34.45 34.45 0 01-14.083 30.833L72.33 150.542a34.442 34.442 0 00-14.205 27.856c0 7.604 2.52 14.998 7.164 21.019l11 14.25a34.452 34.452 0 014.833 33.541l-6.542 16.667a34.431 34.431 0 00-2.35 12.502c0 14.513 9.181 27.537 22.85 32.415l16.959 6.041a34.455 34.455 0 0122.208 25.625l3.25 15.834-43.292 140.71 68.667-21.5 42.75 57.833 39.042-127.62c11.978 9.942 29.282 10.578 41.958 1.542l41.083 126.08 42.75-57.833 68.667 21.5-44.333-136c.291-.958.541-1.875.75-2.875l3.541-17.667a34.454 34.454 0 0122.209-25.625l16.958-6.041c13.67-4.878 22.851-17.902 22.851-32.415 0-4.277-.797-8.517-2.351-12.502l-6.542-16.667a34.45 34.45 0 014.834-33.541l11.041-14.417zm-320.38 7.583c0-65.258 53.7-118.96 118.96-118.96 65.258 0 118.96 53.7 118.96 118.96 0 65.259-53.7 118.96-118.96 118.96-65.233-.069-118.89-53.726-118.96-118.96z"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
);

export default WarrantyRibbon;
